document.addEventListener('DOMContentLoaded', function () {
  // --- Gem alle varianter i window.pv2Variants ---
  if (!window.pv2Variants && window.productVariantsJson) window.pv2Variants = window.productVariantsJson;
  if (!window.pv2Variants && window.variants) window.pv2Variants = window.variants;
  if (!window.pv2Variants && window.Shopify && window.Shopify.product && window.Shopify.product.variants) window.pv2Variants = window.Shopify.product.variants;

  // --- Funktion: Hent nuværende option values ---
  function getCurrentOptionValues() {
    let values = [];
    document.querySelectorAll('.pv2-option-card').forEach(function(card) {
      if (
        card.id === "door-placement-card" ||
        card.id === "extra-door-card" ||
        card.id === "auto-opluk-card" ||
        card.id === "ridge-decoration-card" ||
        card.id === "foundation-type-card" ||
        card.id === "ophaengskroge-card" ||
        card.id === "montage-referral-card"
      ) return;
      const selected = card.querySelector('.pv2-option-value-item.active');
      if (selected) values.push(selected.getAttribute('data-value'));
    });
    return values;
  }

const $ = (sel, ctx = document) => ctx.querySelector(sel);   // <- NY linje



  // --- Funktion: Find valgt variant ---
  function getSelectedVariant() {
    if (!window.pv2Variants) return null;
    const currentValues = getCurrentOptionValues();
    return window.pv2Variants.find(function(v) {
      let opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
      return JSON.stringify(opts) === JSON.stringify(currentValues);
    });
  }

  // --- Funktion: Sæt hidden select til rigtige variant ---
  function updateHiddenSelect(variantId) {
    var select = document.querySelector('select[data-product-select]');
    if (select) {
      select.value = variantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // --- Funktion: Opdater variant-id i url ---
  function updateUrl(variant) {
    if (variant && window.history && window.history.replaceState) {
      const newUrl = window.location.pathname.split('?')[0] + '?variant=' + variant.id;
      window.history.replaceState({}, '', newUrl);
    }
  }


  // --- Funktion: Opdater ekstra priser på alle options ---
  function updateExtraPrices() {
    var picker = document.getElementById('pv2-variant-picker');
    if (!picker) return;
    var productHandle = picker.getAttribute('data-handle');
    if (!productHandle) return;
    document.querySelectorAll('.pv2-option-value-item').forEach(function(option) {
      var value = option.getAttribute('data-value');
      var priceSpan = option.querySelector('.pv2-option-value-price');
      if (!priceSpan) return;
      priceSpan.textContent = '';
      if (
        window.extraPriceMap &&
        window.extraPriceMap[productHandle] &&
        window.extraPriceMap[productHandle][value] !== undefined
      ) {
        var ekstraPris = window.extraPriceMap[productHandle][value];
        priceSpan.textContent = "+ " + ekstraPris; 
        priceSpan.style.fontWeight = "500";
        priceSpan.style.color = "#a8a6a1";
        priceSpan.style.marginLeft = "0px";
      } else {
        priceSpan.textContent = "";
        priceSpan.style.fontWeight = "";
        priceSpan.style.color = "";
        priceSpan.style.marginLeft = "";
      }
    });
  }



  // --- INITIALISÉR BILLEDER I HVER OPTION-CARD ---
  document.querySelectorAll('.pv2-option-card').forEach(function(card) {
    const activeItem = card.querySelector('.pv2-option-value-item.active');
    const imageElem = card.querySelector('.pv2-option-card-image');
    if (activeItem && imageElem && window.imageMap) {
      const value = activeItem.getAttribute('data-value');
      if (window.imageMap[value]) {
        imageElem.src = window.imageMap[value];
        imageElem.style.display = '';
      } else {
        imageElem.style.display = 'none';
      }
    }
  });

  // Sikr at billedet vises fra start på dørplacering
  var doorPlacementCard = document.getElementById('door-placement-card');
  if (doorPlacementCard) {
    var imgElem = doorPlacementCard.querySelector('.pv2-option-card-image');
    if (imgElem) imgElem.style.display = '';
  }

  // --- VÆRDI-CLICK: OPDATER BILLEDE, VARIANT, URL, HIDDEN SELECT, PRIS OG 3D MODEL ---
  document.querySelectorAll('.pv2-option-value-item').forEach(function(item) {
    item.addEventListener('click', function() {
      const card = item.closest('.pv2-option-card');
      // Door placement er IKKE en Shopify variant
      if (card && card.id === 'door-placement-card') {
        let parent = item.closest('.pv2-option-values');
        parent.querySelectorAll('.pv2-option-value-item').forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        const imageElem = card.querySelector('.pv2-option-card-image');
        const newImg = item.getAttribute('data-img');
        if (newImg && imageElem) {
          imageElem.src = newImg;
          imageElem.style.display = '';
        }
        return;
      }
      // Normal variant
      let parent = item.closest('.pv2-option-values');
      if (parent) {
        parent.querySelectorAll('.pv2-option-value-item').forEach(i => i.classList.remove('active'));
      }
      item.classList.add('active');
      const imageElem = card.querySelector('.pv2-option-card-image');
      const newImg = item.getAttribute('data-img');
      if (newImg && imageElem) {
        imageElem.src = newImg;
        imageElem.style.display = '';
      } else if (window.imageMap && imageElem) {
        const value = item.getAttribute('data-value');
        if (window.imageMap[value]) {
          imageElem.src = window.imageMap[value];
          imageElem.style.display = '';
        } else {
          imageElem.style.display = 'none';
        }
      }
      const variant = getSelectedVariant();
      if (variant) {
        updateHiddenSelect(variant.id);
        updateUrl(variant);
        // Opdater “salgspris”
document.querySelectorAll('.price-sale').forEach(function(el) {
  el.textContent = (variant.price / 100).toLocaleString('da-DK', {style: 'currency', currency: 'DKK'});
});



        updateModelViewer(variant);
      }
      updateExtraPrices();
    });
  });

  updateExtraPrices();

  // --- EKSTRA DØR: Bokshåndtering og pris/antal/kommentar ---
  var ekstraDorAktiv = false;
  var ekstraDorVariantId = null;
  var ekstraDorQty = 1;
  var ekstraDorComment = "";
  (function() {
    var extraDoorCard = document.getElementById('extra-door-card');
    if (!extraDoorCard) return;
    var valueItems = extraDoorCard.querySelectorAll('.pv2-option-value-item');
    var optionsWrap = document.getElementById('extra-door-options');
    var variantSelect = document.getElementById('extra-door-variant-select');
    var qtySelect = document.getElementById('extra-door-qty-select');
    var priceEl = document.getElementById('extra-door-price');
    var compareEl = document.getElementById('extra-door-compare');
    var discountEl = document.getElementById('extra-door-discount');
    var commentEl = document.getElementById('extra-door-placement-comment');
    ekstraDorVariantId = variantSelect ? variantSelect.value : null;
    ekstraDorQty = qtySelect ? parseInt(qtySelect.value) : 1;

    function updatePriceUI() {
      if (!variantSelect) return;
      var selected = variantSelect.options[variantSelect.selectedIndex];
      ekstraDorVariantId = selected.value;
      var price = parseFloat(selected.getAttribute('data-price')) * ekstraDorQty;
      var compare = parseFloat(selected.getAttribute('data-compare')) * ekstraDorQty;
      priceEl.textContent = "+ " + fmtDKK(price);
      if (compare > price && compare > 0) {
        compareEl.textContent = "Før " + compare.toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
        var pct = Math.round(100 - (price / compare * 100));
        discountEl.textContent = "Spar " + pct + "%";
        discountEl.style.display = '';
      } else {
        compareEl.textContent = '';
        discountEl.style.display = 'none';
      }
    }

    valueItems.forEach(function(item) {
      item.addEventListener('click', function() {
        valueItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        if (item.getAttribute('data-value') === 'add') {
          optionsWrap.style.display = '';
          ekstraDorAktiv = true;
          updatePriceUI();
        } else {
          optionsWrap.style.display = 'none';
          ekstraDorAktiv = false;
        }
      });
    });

    if (variantSelect) variantSelect.addEventListener('change', function() {
      ekstraDorVariantId = variantSelect.value;
      updatePriceUI();
    });
    if (qtySelect) qtySelect.addEventListener('change', function() {
      ekstraDorQty = parseInt(qtySelect.value);
      updatePriceUI();
    });
    if (commentEl) commentEl.addEventListener('input', function() {
      ekstraDorComment = commentEl.value;
    });

    updatePriceUI();
  })();

  // --- TAGRYGSDEKORATION: Bokshåndtering og pris/variantvalg ---
  var ridgeDecorationAktiv = false;
  var ridgeDecorationVariantId = null;
  (function() {
    var ridgeCard = document.getElementById('ridge-decoration-card');
    if (!ridgeCard) return;
    var valueItems = ridgeCard.querySelectorAll('.pv2-option-value-item');
    var optionsWrap = document.getElementById('ridge-decoration-options');
    var variantSelect = document.getElementById('ridge-decoration-variant-select');
    var priceEl = document.getElementById('ridge-decoration-price');
    var imgEl = document.getElementById('ridge-decoration-img');

    ridgeDecorationVariantId = variantSelect ? variantSelect.value : null;

    function updateRidgeUI() {
      if (!variantSelect) return;
      var selected = variantSelect.options[variantSelect.selectedIndex];
      ridgeDecorationVariantId = selected.value;
      var price = parseFloat(selected.getAttribute('data-price')) || 0;
      var img = selected.getAttribute('data-img');
      priceEl.textContent = "+ " + fmtDKK(price);
      if (img && imgEl) {
        imgEl.src = img;
        imgEl.style.display = '';
      }
    }

    valueItems.forEach(function(item) {
      item.addEventListener('click', function() {
        valueItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        if (item.getAttribute('data-value') === 'add') {
          optionsWrap.style.display = '';
          ridgeDecorationAktiv = true;
          updateRidgeUI();
        } else {
          optionsWrap.style.display = 'none';
          ridgeDecorationAktiv = false;
        }
        setTimeout(updatePv2Summary, 10);
      });
    });

    if (variantSelect) variantSelect.addEventListener('change', function() {
      ridgeDecorationVariantId = variantSelect.value;
      updateRidgeUI();
      setTimeout(updatePv2Summary, 10);
    });

    updateRidgeUI();

    // Eksporter, så det virker i add-to-cart og summary
    window.getRidgeDecorationAktiv = function() { return ridgeDecorationAktiv; }
    window.getRidgeDecorationVariantId = function() { return ridgeDecorationVariantId; }
  })();

  // --- FASTGØRELSE: Bokshåndtering og pris/antal/variantvalg ---
var foundationActive = false;
var foundationVariantId = null;
var foundationQty = 1;
(function() {
  var foundationCard = document.getElementById('foundation-type-card');
  if (!foundationCard) return;
  var valueItems = foundationCard.querySelectorAll('.pv2-option-value-item');
  var optionsWrap = document.getElementById('foundation-accessory-options');
  var variantSelect = document.getElementById('foundation-accessory-variant-select');
  var qtySelect = document.getElementById('foundation-accessory-qty-select');
  var priceEl = document.getElementById('foundation-accessory-price');
  var compareEl = document.getElementById('foundation-accessory-compare');
  var discountEl = document.getElementById('foundation-accessory-discount');
  var imageElem = foundationCard.querySelector('.pv2-option-card-image');
  foundationVariantId = variantSelect ? variantSelect.value : null;
  foundationQty = qtySelect ? parseInt(qtySelect.value) : 1;

  function updatePriceUI() {
    if (!variantSelect) return;
    var selected = variantSelect.options[variantSelect.selectedIndex];
    foundationVariantId = selected.value;
    var price = parseFloat(selected.getAttribute('data-price')) * foundationQty;
    var compare = parseFloat(selected.getAttribute('data-compare')) * foundationQty;
    priceEl.textContent = "+ " + fmtDKK(price);
    if (compare > price && compare > 0) {
      compareEl.textContent = "Før " + compare.toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
      var pct = Math.round(100 - (price / compare * 100));
      discountEl.textContent = "Spar " + pct + "%";
      discountEl.style.display = '';
    } else {
      compareEl.textContent = '';
      discountEl.style.display = 'none';
    }
  }

  valueItems.forEach(function(item) {
    item.addEventListener('click', function() {
      valueItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      // Skift billede
      var newImg = item.getAttribute('data-img');
      if (imageElem && newImg) imageElem.src = newImg;
      // Hvis “skruer” valgt: vis tilkøb
      if (item.getAttribute('data-value') === 'skruer') {
        optionsWrap.style.display = '';
        foundationActive = true;
        updatePriceUI();
      } else {
        optionsWrap.style.display = 'none';
        foundationActive = false;
      }
      setTimeout(updatePv2Summary, 10);
    });
  });

  if (variantSelect) variantSelect.addEventListener('change', function() {
    foundationVariantId = variantSelect.value;
    updatePriceUI();
    setTimeout(updatePv2Summary, 10);
  });
  if (qtySelect) qtySelect.addEventListener('change', function() {
    foundationQty = parseInt(qtySelect.value);
    updatePriceUI();
    setTimeout(updatePv2Summary, 10);
  });

  updatePriceUI();

  // Eksporter til summary/add to cart
  window.getFoundationActive = function() { return foundationActive; }
  window.getFoundationVariantId = function() { return foundationVariantId; }
  window.getFoundationQty = function() { return foundationQty; }
  window.getFoundationPrice = function() {
    if (!variantSelect) return 0;
    var selected = variantSelect.options[variantSelect.selectedIndex];
    return foundationActive ? (parseFloat(selected.getAttribute('data-price')) * foundationQty) : 0;
  }
})();

  

// OPHÆNGSKROGE - Bokshåndtering, add-to-cart & summary
var ophaengskrogeAktiv = false;
var ophaengskrogeVariantId = null;
var ophaengskrogeQty = 5;   // valgte stk (5, 10, ...)
var ophaengskrogePacks = 1; // antal pakker

(function() {
  var card = document.getElementById('ophaengskroge-card');
  if (!card) return;
  var valueItems = card.querySelectorAll('.pv2-option-value-item');
  var optionsWrap = document.getElementById('ophaengskroge-options');
  var variantSelect = document.getElementById('ophaengskroge-variant-select');
  var qtySelect = document.getElementById('ophaengskroge-qty-select');
  var priceEl = document.getElementById('ophaengskroge-price');
  var compareEl = document.getElementById('ophaengskroge-compare');
  var discountEl = document.getElementById('ophaengskroge-discount');
  ophaengskrogeVariantId = variantSelect ? variantSelect.value : null;
  ophaengskrogeQty = qtySelect ? parseInt(qtySelect.value) : 5;
  ophaengskrogePacks = ophaengskrogeQty / 5;

  function updateOphaengskrogePriceUI() {
    if (!variantSelect) return;
    var selected = variantSelect.options[variantSelect.selectedIndex];
    ophaengskrogeVariantId = selected.value;
    
    // Pris og compare PER PAKKE, ganges op med antal pakker
    var price = parseFloat(selected.getAttribute('data-price')) * ophaengskrogePacks;
    var compare = parseFloat(selected.getAttribute('data-compare')) * ophaengskrogePacks;
    priceEl.textContent = "+ " + fmtDKK(price);
    if (compare > price && compare > 0) {
      compareEl.textContent = "Før " + compare.toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
      var pct = Math.round(100 - (price / compare * 100));
      discountEl.textContent = "Spar " + pct + "%";
      discountEl.style.display = '';
    } else {
      compareEl.textContent = '';
      discountEl.style.display = 'none';
    }
  }

  // Aktivér/deaktiver boks
  valueItems.forEach(function(item) {
    item.addEventListener('click', function() {
      valueItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      if (item.getAttribute('data-value') === 'add') {
        optionsWrap.style.display = '';
        ophaengskrogeAktiv = true;
        updateOphaengskrogePriceUI();
      } else {
        optionsWrap.style.display = 'none';
        ophaengskrogeAktiv = false;
      }
      setTimeout(updatePv2Summary, 10);
    });
  });

  if (variantSelect) variantSelect.addEventListener('change', function() {
    ophaengskrogeVariantId = variantSelect.value;
    updateOphaengskrogePriceUI();
    setTimeout(updatePv2Summary, 10);
  });
  if (qtySelect) qtySelect.addEventListener('change', function() {
    ophaengskrogeQty = parseInt(qtySelect.value);
    ophaengskrogePacks = ophaengskrogeQty / 5;
    updateOphaengskrogePriceUI();
    setTimeout(updatePv2Summary, 10);
  });

  updateOphaengskrogePriceUI();

  // Eksporter getters til add-to-cart og summary
  window.getOphaengskrogeAktiv = function() { return ophaengskrogeAktiv; }
  window.getOphaengskrogeVariantId = function() { return ophaengskrogeVariantId; }
  window.getOphaengskrogeQty = function() { return ophaengskrogeQty; }
  window.getOphaengskrogePacks = function() { return ophaengskrogePacks; }
})();



  // --- AUTOMATISK OPLUK: Bokshåndtering og pris/antal/variantvalg ---
  var autoOplukAktiv = false;
  var autoOplukVariantId = null;
  var autoOplukQty = 1;
  (function() {
    var autoOplukCard = document.getElementById('auto-opluk-card');
    if (!autoOplukCard) return;
    var valueItems = autoOplukCard.querySelectorAll('.pv2-option-value-item');
    var optionsWrap = document.getElementById('auto-opluk-options');
    var variantSelect = document.getElementById('auto-opluk-variant-select');
    var qtySelect = document.getElementById('auto-opluk-qty-select');
    var priceEl = document.getElementById('auto-opluk-price');
    var compareEl = document.getElementById('auto-opluk-compare');
    var discountEl = document.getElementById('auto-opluk-discount');

    autoOplukVariantId = variantSelect ? variantSelect.value : null;
    autoOplukQty = qtySelect ? parseInt(qtySelect.value) : 1;

    function updateAutoOplukPriceUI() {
      if (!variantSelect) return;
      var selected = variantSelect.options[variantSelect.selectedIndex];
      autoOplukVariantId = selected.value;
      var price = parseFloat(selected.getAttribute('data-price')) * autoOplukQty;
      var compare = parseFloat(selected.getAttribute('data-compare')) * autoOplukQty;
      priceEl.textContent = "+ " + fmtDKK(price);
      if (compare > price && compare > 0) {
        compareEl.textContent = "Før " + compare.toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
        var pct = Math.round(100 - (price / compare * 100));
        discountEl.textContent = "Spar " + pct + "%";
        discountEl.style.display = '';
      } else {
        compareEl.textContent = '';
        discountEl.style.display = 'none';
      }
    }

    // Preselect “Ingen automatisk opluk”
    valueItems.forEach(function(item) {
      if (item.getAttribute('data-value') === 'none') {
        item.classList.add('active');
        optionsWrap.style.display = 'none';
        autoOplukAktiv = false;
      }
    });

    valueItems.forEach(function(item) {
      item.addEventListener('click', function() {
        valueItems.forEach(i => i.classList.remove('active'));
        item.classList.add('active');
        if (item.getAttribute('data-value') === 'add') {
          optionsWrap.style.display = '';
          autoOplukAktiv = true;
          updateAutoOplukPriceUI();
        } else {
          optionsWrap.style.display = 'none';
          autoOplukAktiv = false;
        }
      });
    });

    if (variantSelect) variantSelect.addEventListener('change', function() {
      autoOplukVariantId = variantSelect.value;
      updateAutoOplukPriceUI();
    });
    if (qtySelect) qtySelect.addEventListener('change', function() {
      autoOplukQty = parseInt(qtySelect.value);
      updateAutoOplukPriceUI();
    });

    updateAutoOplukPriceUI();

    // Eksporter, så det virker i add-to-cart
    window.getAutoOplukAktiv = function() { return autoOplukAktiv; }
    window.getAutoOplukVariantId = function() { return autoOplukVariantId; }
    window.getAutoOplukQty = function() { return autoOplukQty; }
  })();

// --- HENVISNING TIL MONTØR: Bokshåndtering og prisestimat ---
var montageReferralAktiv = false;
var montageReferralVariantId = window.montageReferralVariantId || null;
(function() {
  var card = document.getElementById('montage-referral-card');
  if (!card) return;
  var valueItems = card.querySelectorAll('.pv2-option-value-item');
  var optionsWrap = document.getElementById('montage-referral-options');
  var priceEl = document.getElementById('montage-referral-price');
  var variantSelect = document.getElementById('montage-referral-variant-select');
  var priceRangeEl = document.getElementById('montage-referral-pricerange');

  // Hent priser fra DOM (de skjulte divs)
  function getAssemblyPricesFromDOM() {
    var base = parseFloat(document.getElementById('assemblyBasePrice')?.innerText.replace(/\D/g, '')) || 0;
    var sjaelland = parseFloat(document.getElementById('addonSjaelland')?.innerText.replace(/\D/g, '')) || 0;
    var punktstobning = parseFloat(document.getElementById('addonPunktstoebning')?.innerText.replace(/\D/g, '')) || 0;
    return { base, sjaelland, punktstobning };
  }

  // Udregn og vis prisinterval i UI
  var prices = getAssemblyPricesFromDOM();
  var minPrice = prices.base;
  var maxPrice = prices.base + prices.sjaelland + prices.punktstobning;
  var minPriceFormatted = minPrice.toLocaleString('da-DK', {style:'currency', currency:'DKK'}).replace(',00','');
  var maxPriceFormatted = maxPrice.toLocaleString('da-DK', {style:'currency', currency:'DKK'}).replace(',00','');
  if (priceRangeEl) priceRangeEl.textContent = minPriceFormatted + ' - ' + maxPriceFormatted;

  // Opdater aktuel variant/pris ved valg
  function updatePriceUI() {
    // Hvis du har flere varianter på montering
    if (variantSelect && priceEl) {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      montageReferralVariantId = selected.value;
      var price = parseFloat(selected.getAttribute('data-price'));
      priceEl.textContent = "+ " + fmtDKK(price);
    }
  }

  valueItems.forEach(function(item) {
    item.addEventListener('click', function() {
      valueItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      if (item.getAttribute('data-value') === 'add') {
        optionsWrap.style.display = '';
        montageReferralAktiv = true;
        updatePriceUI();
      } else {
        optionsWrap.style.display = 'none';
        montageReferralAktiv = false;
      }
    });
  });

  // Pristekst styling
  var priceTextEl = document.getElementById('montage-referral-pricetext');
  if (priceTextEl) {
    priceTextEl.textContent = "Estimeret monteringspris: ";
    priceTextEl.style.color = "#333";
    priceTextEl.style.fontWeight = "400";
  }

  if (variantSelect) variantSelect.addEventListener('change', updatePriceUI);

  // Første gang, så det vises fra start
  updatePriceUI();

  // Eksporter til add-to-cart
  window.getMontageReferralAktiv = function() { return montageReferralAktiv; }
  window.getMontageReferralVariantId = function() { return montageReferralVariantId; }
})();

  // ---- HYLDE-TILKØB: Mix og mængderabat ----
function getShelfDiscountRate(total) {
  if (total >= 6) return 0.30;
  if (total === 5) return 0.25;
  if (total === 4) return 0.20;
  if (total === 3) return 0.15;
  if (total === 2) return 0.10;
  return 0;
}

// Opdater pris, rabat og valgte hylder
function updateShelfAddonSummary() {
  let inputs = document.querySelectorAll('.shelf-qty-input');
  let totalShelves = 0, subtotal = 0, shelfLines = [];
  let shelfSelections = [];
  inputs.forEach(input => {
    let qty = parseInt(input.value) || 0;
    let price = parseFloat(input.getAttribute('data-price'));
    let title = input.getAttribute('data-title');
    let prod = input.getAttribute('data-prod');
    let variant_id = input.getAttribute('data-variant');
    if (qty > 0) {
      totalShelves += qty;
      subtotal += price * qty;
      shelfLines.push(`${prod} - ${title} x${qty}`);
      shelfSelections.push({
        id: variant_id,
        quantity: qty,
        name: `${prod} - ${title}`
      });
    }
  });
  let discount = getShelfDiscountRate(totalShelves);
  let total = subtotal * (1 - discount);

  // Format price texts
  let normalPriceTxt = subtotal.toLocaleString('da-DK', {style:'currency', currency:'DKK'});
  let discountPriceTxt = total.toLocaleString('da-DK', {style:'currency', currency:'DKK'});
  let discountTxt = discount > 0
    ? `<span class="shelf-discount-label">${Math.round(discount*100)}% rabat</span>`
    : `<span class="shelf-discount-label"></span>`;

  // Byg oversigten
  let summary = '';
  if (totalShelves > 0) {
    summary += 'Valgte hylder:<br>';
    shelfLines.forEach(line => {
      summary += `<div class="shelf-selected-line">${line}</div>`;
    });
    summary += `
      <div class="shelf-price-row">
        <span>
          <span class="shelf-normal-label">${normalPriceTxt}</span>
          <span class="shelf-total-label">${discountPriceTxt}</span>
        </span>
        ${discountTxt}
      </div>
    `;
  } else {
    summary += 'Ingen hylder valgt<br>';
    summary += `
      <div class="shelf-price-row">
        <span>
          <span class="shelf-normal-label"></span>
          <span class="shelf-total-label">0 kr.</span>
        </span>
        ${discountTxt}
      </div>
    `;
  }
  var shelfAddonSummary = document.getElementById('shelf-addon-summary');
  if(shelfAddonSummary) shelfAddonSummary.innerHTML = summary;

  // Gem valgte hylder til brug i add-to-cart
  window.selectedShelvesForCart = shelfSelections.map(sel => ({
    id: sel.id,
    quantity: sel.quantity,
    
  }));

  window.shelfAddonTotal = total;
  window.shelfAddonDiscount = discount;
}

if (document.getElementById('shelf-addon-options')) {
  document.querySelectorAll('.shelf-qty-input').forEach(input => {
    input.addEventListener('input', function() {
      updateShelfAddonSummary();
      setTimeout(updatePv2Summary, 10);
    });
  });
  updateShelfAddonSummary();
  setTimeout(updatePv2Summary, 10);
}

  // Plus/minus knapper til hylder
document.querySelectorAll('.shelf-qty-wrap').forEach(function(wrap){
  const minus = wrap.querySelector('.shelf-qty-minus');
  const plus = wrap.querySelector('.shelf-qty-plus');
  const input = wrap.querySelector('.shelf-qty-input');
  if (!minus || !plus || !input) return;
  minus.addEventListener('click', function(){
    let val = parseInt(input.value) || 0;
    if (val > 0) input.value = val - 1;
    input.dispatchEvent(new Event('input'));
  });
  plus.addEventListener('click', function(){
    let val = parseInt(input.value) || 0;
    if (val < 6) input.value = val + 1;
    input.dispatchEvent(new Event('input'));
  });
});

  

  // --- ADD-TO-CART: Tilføj hovedprodukt og tilkøb ---
  const addToCartBtn = document.getElementById('pv2-add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      const variant = getSelectedVariant();
      if (!variant) {
        alert("Vælg venligst en variant først.");
        return;
      }

      // Dørplacering property
      const doorPlacementCard = document.getElementById('door-placement-card');
      let properties = {};
      if (doorPlacementCard) {
        const selected = doorPlacementCard.querySelector('.pv2-option-value-item.active');
        if (selected) {
          properties['Placering af dør'] = selected.getAttribute('data-value');
        }
      }

      



      // Saml alle varer (hovedprodukt + tilkøb) i et array
      let items = [{
        id: variant.id,
        quantity: 1,
        properties: properties
      }];

      // Tilføj valgte hylder til items
if (window.selectedShelvesForCart && window.selectedShelvesForCart.length) {
  window.selectedShelvesForCart.forEach(item => items.push(item));
}


      // Ekstra dør
      if (ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
        let ekstraDorProps = { "Placering ekstra dør": ekstraDorComment };
        items.push({
          id: ekstraDorVariantId,
          quantity: ekstraDorQty,
          properties: ekstraDorProps
        });
      }

      // Automatisk opluk
      if (window.getAutoOplukAktiv && window.getAutoOplukAktiv() && window.getAutoOplukVariantId && window.getAutoOplukQty && window.getAutoOplukQty() > 0) {
        items.push({
          id: window.getAutoOplukVariantId(),
          quantity: window.getAutoOplukQty()
        });
      }

// Ophængskroge (5 stk./pakke)
if (window.getOphaengskrogeAktiv && window.getOphaengskrogeAktiv() && window.getOphaengskrogeVariantId && window.getOphaengskrogePacks && window.getOphaengskrogePacks() > 0) {
  items.push({
    id: window.getOphaengskrogeVariantId(),
    quantity: window.getOphaengskrogePacks() // antal pakker!
  });
}



      // Fastgørelse - dækkapper til sokkel
if (window.getFoundationActive && window.getFoundationActive() && window.getFoundationVariantId && window.getFoundationQty && window.getFoundationQty() > 0) {
  items.push({
    id: window.getFoundationVariantId(),
    quantity: window.getFoundationQty()
  });
}


      // Tagrygsdekoration
      if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv() && window.getRidgeDecorationVariantId) {
        items.push({
          id: window.getRidgeDecorationVariantId(),
          quantity: 1
        });
      }

      // Henvisning til montør
      if (window.getMontageReferralAktiv && window.getMontageReferralAktiv() && window.getMontageReferralVariantId) {
        let montageReferralVariantId = window.getMontageReferralVariantId();
        if (montageReferralVariantId) {
          items.push({
            id: montageReferralVariantId,
            quantity: 1
          });
        }
      }

      // Hvis der er valgt ekstra dør, tjek at kommentar er udfyldt
if (ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
  let kommentar = document.getElementById('extra-door-placement-comment')?.value?.trim();
  if (!kommentar) {
    alert("Du skal udfylde hvor den ekstra dør skal placeres.");
    // Sæt evt. fokus i feltet for brugervenlighed:
    document.getElementById('extra-door-placement-comment').focus();
    return; // Stop submit!
  }
}


      // Tilføj ALLE varer på én gang
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(response) {
        if (!response.ok) throw new Error("Kunne ikke lægge i kurv.");
        return response.json();
      })
      .then(function() {
        // Luk modal osv.
        var overlay = document.getElementById('pv2-design-overlay');
        if (overlay) {
          overlay.classList.remove('active');
          document.body.style.overflow = '';
          var mainContent = document.getElementById('pv2-main-content');
          if (mainContent) mainContent.style.filter = '';
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function(err) {
        alert("Der opstod en fejl: " + err.message);
      });
    });
  }

function updateComparePriceDynamic () {
  const variant = getSelectedVariant();
  const els     = document.querySelectorAll('.price-compare');
  if (!variant || !els.length) return;

  /* 1) “Basis” compare-pris (kr) fra hovedvarianten  */
  let compare = (variant.compare_at_price && variant.compare_at_price > variant.price)
              ? variant.compare_at_price / 100   // øre → kr
              : variant.price / 100;             // ingen rabat på varianten

  /* 2)  Læg alle aktive add-ons oveni  (data-price er i øre)    */
  const add = v => compare += (v || 0);           // øre → kr

  /* Ekstra dør */
  if (ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty>0){
    const p = +$('#extra-door-variant-select')?.selectedOptions[0]?.dataset.price||0;
    add(p * ekstraDorQty);
  }
  /* Ophængskroge */
  if (window.getOphaengskrogeAktiv && window.getOphaengskrogeAktiv()){
    const packs = window.getOphaengskrogePacks();
    const p = +$('#ophaengskroge-variant-select')?.selectedOptions[0]?.dataset.price||0;
    add(p * packs);
  }
  /* Foundation */
  add( window.getFoundationPrice ? window.getFoundationPrice()*100 : 0 );

  /* Auto-opluk */
  if (window.getAutoOplukAktiv && window.getAutoOplukAktiv()){
    const qty = window.getAutoOplukQty();
    const p   = +$('#auto-opluk-variant-select')?.selectedOptions[0]?.dataset.price||0;
    add(p * qty);
  }
  /* Ridge */
  if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv()){
    add(+$('#ridge-decoration-variant-select')?.selectedOptions[0]?.dataset.price||0);
  }
  /* Montage */
  if (window.getMontageReferralAktiv && window.getMontageReferralAktiv()){
    add(+$('#montage-referral-variant-select')?.selectedOptions[0]?.dataset.price||0);
  }
  /* Hylder */
  if (window.selectedShelvesForCart?.length){
    let shelf = 0;
    window.selectedShelvesForCart.forEach(sel=>{
      const price = +$(`.shelf-qty-input[data-variant="${sel.id}"]`)?.dataset.price||0;
      shelf += price*sel.quantity;
    });
    const disc = getShelfDiscountRate(window.selectedShelvesForCart.reduce((a,s)=>a+s.quantity,0));
    add(shelf * (1-disc));
  }

  /* 3)  Vis / skjul  */
  const formatted = compare.toLocaleString('da-DK',{style:'currency',currency:'DKK'}).replace(',00','');
  const saleNow   = parseFloat($('.price-sale')?.textContent.replace(/\D/g,'')||0)/100;

  els.forEach(el=>{
    if (compare > saleNow){
      el.textContent = 'Før ' + formatted;
      el.style.display = '';
    }else{
      el.textContent = '';
      el.style.display = 'none';
    }
  });
}

  // --- OPSUMMERING: Dynamisk totalpris & oversigt ---
  function pv2FormatPrice(val) {
    return (val || 0).toLocaleString('da-DK', {style:'currency', currency:'DKK'}).replace(',00','');
  }

  // Brug én fælles helper til DKK-visning
function fmtDKK(val){
  return (val||0)
    .toLocaleString('da-DK',{
      style:'currency',
      currency:'DKK',
      minimumFractionDigits:0,   // ← ingen ,00 hvis helt tal
      maximumFractionDigits:2    // ← men behold ,50 / ,75 osv.
    });
}


  function updatePv2Summary() {
    // Hovedprodukt
    const variant = getSelectedVariant();
    let total = 0;
    let details = [];
    if (variant) {
      total = variant.price / 100; // Omregn til kroner!
      details.push(`${variant.title} <span style="float:right;">${pv2FormatPrice(variant.price / 100)}</span>`);
    }



    // Ekstra dør
    if (typeof ekstraDorAktiv !== 'undefined' && ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
      let select = document.getElementById('extra-door-variant-select');
      if (select) {
        let opt = select.options[select.selectedIndex];
        let price = parseFloat(opt.getAttribute('data-price')) * ekstraDorQty;
        total += price;
        details.push(`Ekstra dør x${ekstraDorQty} <span style="float:right;">${pv2FormatPrice(price)}</span>`);
      }
    }

    

// Ophængskroge i opsummering
if (window.getOphaengskrogeAktiv && window.getOphaengskrogeAktiv() && window.getOphaengskrogeVariantId && window.getOphaengskrogePacks && window.getOphaengskrogePacks() > 0) {
  let select = document.getElementById('ophaengskroge-variant-select');
  let txt = '';
  let pris = '';
  let qty = window.getOphaengskrogeQty();      // antal stk valgt (5,10,15..)
  let packs = window.getOphaengskrogePacks();  // antal pakker
  if (select) {
    let opt = select.options[select.selectedIndex];
    txt = opt.textContent;
    pris = (parseFloat(opt.getAttribute('data-price')) * packs).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
  }
  details.push(`Ophængskroge (${txt}) x${packs} pakker (${qty} stk.) <span style="float:right;">${pris}</span>`);
  total += parseFloat(pris.replace(/\./g,'').replace(',','.')) || 0; // eller træk prisen direkte fra ovenfor!
}



      // FASTGØRELSE (dækkappe til sokkel)
  if (window.getFoundationActive && window.getFoundationActive() && window.getFoundationVariantId && window.getFoundationQty && window.getFoundationQty() > 0) {
    let price = window.getFoundationPrice ? window.getFoundationPrice() : 0;
    details.push(`Dækkapper til sokkel x${window.getFoundationQty()} <span style="float:right;">${pv2FormatPrice(price)}</span>`);
    total += price;
  }


    // Automatisk opluk
    if (window.getAutoOplukAktiv && window.getAutoOplukAktiv() && window.getAutoOplukVariantId && window.getAutoOplukQty && window.getAutoOplukQty() > 0) {
      let select = document.getElementById('auto-opluk-variant-select');
      if (select) {
        let opt = select.options[select.selectedIndex];
        let price = parseFloat(opt.getAttribute('data-price')) * window.getAutoOplukQty();
        total += price;
        details.push(`Automatisk opluk x${window.getAutoOplukQty()} <span style="float:right;">${pv2FormatPrice(price)}</span>`);
      }
    }

    // Tagrygsdekoration
    if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv() && window.getRidgeDecorationVariantId) {
      let select = document.getElementById('ridge-decoration-variant-select');
      if (select) {
        let opt = select.options[select.selectedIndex];
        let price = parseFloat(opt.getAttribute('data-price')) || 0;
        total += price;
        details.push(`Tagrygsdekoration <span style="float:right;">${pv2FormatPrice(price)}</span>`);
      }
    }

    // Henvisning til ekstern montør
    if (window.getMontageReferralAktiv && window.getMontageReferralAktiv() && window.getMontageReferralVariantId) {
      let select = document.getElementById('montage-referral-variant-select');
      if (select) {
        let opt = select.options[select.selectedIndex];
        let price = parseFloat(opt.getAttribute('data-price')) || 0;
        total += price;
        details.push(`Henvisning til montør <span style="float:right;">${pv2FormatPrice(price)}</span>`);
      }
    }

    // HYLDERTILKØB: Læg til total og vis i detalje
if (window.selectedShelvesForCart && window.selectedShelvesForCart.length) {
  let shelfTotal = 0, shelfLines = [];
  window.selectedShelvesForCart.forEach(function(sel){
    let qty = sel.quantity;
    let input = document.querySelector('.shelf-qty-input[data-variant="'+sel.id+'"]');
    let price = input ? parseFloat(input.getAttribute('data-price')) : 0;
    shelfTotal += price * qty;
    shelfLines.push(sel.name + ' x' + qty);
  });
  let discount = getShelfDiscountRate(window.selectedShelvesForCart.reduce((acc, s) => acc + s.quantity, 0));
  let shelfDiscountAmount = shelfTotal * discount;
  let shelfTotalWithDiscount = shelfTotal - shelfDiscountAmount;
  if(shelfTotal > 0){
    details.push(
      `Hylder: ${shelfLines.join(', ')} <span style="float:right;">${pv2FormatPrice(shelfTotalWithDiscount)}</span>` +
      (discount > 0 ? `<br><span style="color:#35a250;">Rabat på hylder: -${pv2FormatPrice(shelfDiscountAmount)}</span>` : "")
    );
    total += shelfTotalWithDiscount;
  }
}


    var summaryTotal = document.getElementById('pv2-summary-total');
    if(summaryTotal) summaryTotal.textContent = pv2FormatPrice(total);

    var summaryDetails = document.getElementById('pv2-summary-details');
    if(summaryDetails) summaryDetails.innerHTML = details.join('<br>');

    var stickyPrice = document.getElementById('sticky-summary-price');
if (stickyPrice) stickyPrice.textContent = pv2FormatPrice(total);

  }



  // Robust: Sørg for at updatePv2Summary kaldes på *ALLE* til-/fravalg af ekstra dør/opluk/tagrygsdekoration/montør
  ['click', 'change', 'input'].forEach(function(eventName) {
    [
      '.pv2-option-value-item',
      '#extra-door-variant-select',
      '#extra-door-qty-select',
      '#auto-opluk-variant-select',
      '#auto-opluk-qty-select',
      '#ridge-decoration-card .pv2-option-value-item',
      '#ridge-decoration-variant-select',
      '#montage-referral-card .pv2-option-value-item',
      '#montage-referral-variant-select'
    ].forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        el.addEventListener(eventName, function() {
          setTimeout(updatePv2Summary, 10);
        });
      });
    });
  });

  // Også på load
  updatePv2Summary();

  

  // --- SIKKER event listeners på alle summary-knapper og modal ---
  var overviewBtn = document.getElementById('pv2-summary-overview-btn');
  if (overviewBtn) {
    overviewBtn.addEventListener('click', function() {
      updateSummaryModal();
      var modal = document.getElementById('pv2-summary-modal');
      if(modal) modal.classList.add('active');
    });
  }

  var closeBtn = document.getElementById('pv2-summary-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      var modal = document.getElementById('pv2-summary-modal');
      if(modal) modal.classList.remove('active');
    });
  }

  var summaryModal = document.getElementById('pv2-summary-modal');
  if (summaryModal) {
    summaryModal.addEventListener('click', function(e) {
      if(e.target === this) this.classList.remove('active');
    });
  }

  var summaryAddToCartBtn = document.getElementById('pv2-summary-add-to-cart');
  if(summaryAddToCartBtn){
    summaryAddToCartBtn.addEventListener('click', function(e){
      e.preventDefault();
      if (typeof addToCartBtn !== "undefined" && addToCartBtn) {
        addToCartBtn.click();
      }
    });
  }

  var summaryModalAddToCart = document.getElementById('pv2-summary-modal-add-to-cart');
  if(summaryModalAddToCart){
    summaryModalAddToCart.addEventListener('click', function(e){
      e.preventDefault();
      if (typeof addToCartBtn !== "undefined" && addToCartBtn) {
        addToCartBtn.click();
      }
    });
  }

  // Modal synkroniseres med summary-box
  function updateSummaryModal() {
    var productTitle = document.getElementById('pv2-summary-product-title');
    var modalProductTitle = document.getElementById('pv2-summary-modal-product-title');
    if(productTitle && modalProductTitle) modalProductTitle.textContent = productTitle.textContent;

    var summaryTotal = document.getElementById('pv2-summary-total');
    var modalTotal = document.getElementById('pv2-summary-modal-total');
    if(summaryTotal && modalTotal) modalTotal.textContent = summaryTotal.textContent;

    var listElem = document.getElementById('pv2-summary-list');
    let lines = [];
    var variant = getSelectedVariant();
    if (variant) {
      lines.push(
        `<div class="pv2-summary-list-row">
          <span class="pv2-summary-list-label">${variant.title}</span>
          <span class="pv2-summary-list-price">${(variant.price/100).toLocaleString('da-DK', {style:'currency', currency:'DKK'})}</span>
        </div>`
      );
    }
    var doorPlacement = '';
    var doorCard = document.getElementById('door-placement-card');
    if (doorCard) {
      var sel = doorCard.querySelector('.pv2-option-value-item.active');
      if (sel) {
        doorPlacement = sel.getAttribute('data-value');
        lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Placering af dør</span><span class="pv2-summary-list-value">${doorPlacement}</span></div>`);
      }
    }
    // Ekstra dør
    if (typeof ekstraDorAktiv !== 'undefined' && ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
      let select = document.getElementById('extra-door-variant-select');
      let txt = '';
      let pris = '';
      if (select) {
        let opt = select.options[select.selectedIndex];
        txt = opt.textContent;
        pris = (parseFloat(opt.getAttribute('data-price')) * ekstraDorQty).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
      }
      let kommentar = document.getElementById('extra-door-placement-comment')?.value || '';
      lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Ekstra dør (${txt}) x${ekstraDorQty}</span><span class="pv2-summary-list-price">${pris}</span></div>`);
      if (kommentar) lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Placering ekstra dør</span><span class="pv2-summary-list-value">${kommentar}</span></div>`);
    }
    // Automatisk opluk
    if (window.getAutoOplukAktiv && window.getAutoOplukAktiv() && window.getAutoOplukVariantId && window.getAutoOplukQty && window.getAutoOplukQty() > 0) {
      let select = document.getElementById('auto-opluk-variant-select');
      let txt = '';
      let pris = '';
      if (select) {
        let opt = select.options[select.selectedIndex];
        txt = opt.textContent;
        pris = (parseFloat(opt.getAttribute('data-price')) * window.getAutoOplukQty()).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
      }
      lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Automatisk opluk (${txt}) x${window.getAutoOplukQty()}</span><span class="pv2-summary-list-price">${pris}</span></div>`);
    }
    // Tagrygsdekoration
    if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv() && window.getRidgeDecorationVariantId) {
      let select = document.getElementById('ridge-decoration-variant-select');
      let txt = '';
      let pris = '';
      if (select) {
        let opt = select.options[select.selectedIndex];
        txt = opt.textContent;
        pris = (parseFloat(opt.getAttribute('data-price'))).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
      }
      lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Tagrygsdekoration (${txt})</span><span class="pv2-summary-list-price">${pris}</span></div>`);
    }

    
    // Henvisning til montør
    if (window.getMontageReferralAktiv && window.getMontageReferralAktiv() && window.getMontageReferralVariantId) {
      let select = document.getElementById('montage-referral-variant-select');
      let txt = '';
      let pris = '';
      if (select) {
        let opt = select.options[select.selectedIndex];
        txt = opt.textContent;
        pris = (parseFloat(opt.getAttribute('data-price'))).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
      }
      lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Henvisning til montør (${txt})</span><span class="pv2-summary-list-price">${pris}</span></div>`);
    }
    if (listElem) listElem.innerHTML = lines.join('');
  }

  document.querySelectorAll('.pv2-option-value-item').forEach(function(item) {
  item.addEventListener('click', function() {
    // Fjern 'active' fra alle søskende (indenfor samme optionsgruppe)
    item.parentNode.querySelectorAll('.pv2-option-value-item').forEach(function(sibling) {
      sibling.classList.remove('active');
      sibling.setAttribute('aria-pressed', 'false');
    });
    // Tilføj 'active' til det valgte
    item.classList.add('active');
    item.setAttribute('aria-pressed', 'true');
  });
});

  // --- OPDATER sticky-summary-box (kun sticky) ---
function updateStickySummaryBox() {
  var stickyPrice = document.getElementById('sticky-summary-price');
  var stickyDetails = document.getElementById('sticky-summary-details');
  var variant = getSelectedVariant();
  let price = 0;
  let details = [];

  // Hovedvariant
  if (variant) {
    price = variant.price / 100;
    details.push(`${variant.title}`);
  }

  // Placering af dør
  var doorCard = document.getElementById('door-placement-card');
  if (doorCard) {
    var sel = doorCard.querySelector('.pv2-option-value-item.active');
    if (sel) {
      details.push(`Placering af dør: ${sel.getAttribute('data-value')}`);
    }
  }

  // Ekstra dør
  if (typeof ekstraDorAktiv !== 'undefined' && ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
    details.push(`Ekstra dør x${ekstraDorQty}`);
  }

  // Automatisk opluk
  if (window.getAutoOplukAktiv && window.getAutoOplukAktiv() && window.getAutoOplukQty && window.getAutoOplukQty() > 0) {
    details.push(`Automatisk opluk x${window.getAutoOplukQty()}`);
  }

  // Tagrygsdekoration
  if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv()) {
    details.push(`Tagrygsdekoration`);
  }

  // Henvisning til montør
  if (window.getMontageReferralAktiv && window.getMontageReferralAktiv()) {
    details.push(`Montørhenvisning`);
  }

  // Hylder (hvis valgt)
  if (window.selectedShelvesForCart && window.selectedShelvesForCart.length) {
    let shelfTitles = window.selectedShelvesForCart.map(sel => sel.name + ' x' + sel.quantity);
    details.push('Hylder: ' + shelfTitles.join(', '));
  }

  // Ophængskroge (hvis valgt)
  if (window.getOphaengskrogeAktiv && window.getOphaengskrogeAktiv() && window.getOphaengskrogeQty && window.getOphaengskrogeQty() > 0) {
    details.push('Ophængskroge: ' + window.getOphaengskrogeQty() + ' stk.');
  }

  // Fastgørelse (metode/variant)
  if (window.getFoundationActive && window.getFoundationActive() && window.getFoundationVariantId && window.getFoundationQty && window.getFoundationQty() > 0) {
    let select = document.getElementById('foundation-accessory-variant-select');
    let txt = '';
    if (select) {
      let opt = select.options[select.selectedIndex];
      txt = opt.textContent;
    }
    details.push('Fastgørelse: ' + txt + ' x' + window.getFoundationQty());
  }

  if (stickyPrice) stickyPrice.textContent = fmtDKK(price);
  if (stickyDetails) stickyDetails.innerHTML = details.join('<br>');
}

// --- OPDATER modal-oversigten (kun modal) ---
function updateSummaryModal() {
  var modalProductTitle = document.getElementById('pv2-summary-modal-product-title');
  var modalTotal = document.getElementById('pv2-summary-modal-total');
  var listElem = document.getElementById('pv2-summary-list');
  let lines = [];
  var variant = getSelectedVariant();
  if (variant) {
    lines.push(
      `<div class="pv2-summary-list-row">
        <span class="pv2-summary-list-label">${variant.title}</span>
        <span class="pv2-summary-list-price">${(variant.price/100).toLocaleString('da-DK', {style:'currency', currency:'DKK'})}</span>
      </div>`
    );
  }

  // Placering af dør
  var doorCard = document.getElementById('door-placement-card');
  if (doorCard) {
    var sel = doorCard.querySelector('.pv2-option-value-item.active');
    if (sel) {
      lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Placering af dør</span><span class="pv2-summary-list-value">${sel.getAttribute('data-value')}</span></div>`);
    }
  }

  // Ekstra dør
  if (typeof ekstraDorAktiv !== 'undefined' && ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
    let select = document.getElementById('extra-door-variant-select');
    let txt = '';
    let pris = '';
    if (select) {
      let opt = select.options[select.selectedIndex];
      txt = opt.textContent;
      pris = (parseFloat(opt.getAttribute('data-price')) * ekstraDorQty).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
    }
    let kommentar = document.getElementById('extra-door-placement-comment')?.value || '';
    lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Ekstra dør (${txt}) x${ekstraDorQty}</span><span class="pv2-summary-list-price">${pris}</span></div>`);
    if (kommentar) lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Placering ekstra dør</span><span class="pv2-summary-list-value">${kommentar}</span></div>`);
  }

  // Automatisk opluk
  if (window.getAutoOplukAktiv && window.getAutoOplukAktiv() && window.getAutoOplukQty && window.getAutoOplukQty() > 0) {
    let select = document.getElementById('auto-opluk-variant-select');
    let txt = '';
    let pris = '';
    if (select) {
      let opt = select.options[select.selectedIndex];
      txt = opt.textContent;
      pris = (parseFloat(opt.getAttribute('data-price')) * window.getAutoOplukQty()).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
    }
    lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Automatisk opluk (${txt}) x${window.getAutoOplukQty()}</span><span class="pv2-summary-list-price">${pris}</span></div>`);
  }

  // Tagrygsdekoration
  if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv() && window.getRidgeDecorationVariantId) {
    let select = document.getElementById('ridge-decoration-variant-select');
    let txt = '';
    let pris = '';
    if (select) {
      let opt = select.options[select.selectedIndex];
      txt = opt.textContent;
      pris = (parseFloat(opt.getAttribute('data-price'))).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
    }
    lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Tagrygsdekoration (${txt})</span><span class="pv2-summary-list-price">${pris}</span></div>`);
  }

 // Henvisning til montør
if (window.getMontageReferralAktiv && window.getMontageReferralAktiv() && window.getMontageReferralVariantId) {
  let select = document.getElementById('montage-referral-variant-select');
  let txt = '';
  if (select) {
    let opt = select.options[select.selectedIndex];
    txt = opt.textContent;
  }
  lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Henvisning til montør (${txt})</span><span class="pv2-summary-list-price">0 kr</span></div>`);
}


// HYLDERTILKØB: Hver hylde på egen linje
if (window.selectedShelvesForCart && window.selectedShelvesForCart.length) {
  let totalShelves = 0;
  let shelfTotal = 0;
  window.selectedShelvesForCart.forEach(function(sel){
    let qty = sel.quantity;
    let input = document.querySelector('.shelf-qty-input[data-variant="'+sel.id+'"]');
    let price = input ? parseFloat(input.getAttribute('data-price')) : 0;
    let totalLinePrice = price * qty;
    totalShelves += qty;
    shelfTotal += totalLinePrice;
    lines.push(
      `<div class="pv2-summary-list-row">
        <span class="pv2-summary-list-label">${sel.name} x${qty}</span>
        <span class="pv2-summary-list-price">${pv2FormatPrice(totalLinePrice)}</span>
      </div>`
    );
  });
  // Vis evt. samlet rabat, hvis du ønsker det
  let discount = getShelfDiscountRate(totalShelves);
  let shelfDiscountAmount = shelfTotal * discount;
  if (discount > 0) {
    lines.push(
      `<div class="pv2-summary-list-row">
        <span class="pv2-summary-list-label" style="color:#fe8748;">Rabat på hylder</span>
        <span class="pv2-summary-list-price" style="color:#fe8748;">-${pv2FormatPrice(shelfDiscountAmount)}</span>
      </div>`
    );
  }
}



  // Ophængskroge (vis navn, variant, antal til venstre – pris til højre)
if (window.getOphaengskrogeAktiv && window.getOphaengskrogeAktiv() && window.getOphaengskrogeVariantId && window.getOphaengskrogePacks && window.getOphaengskrogePacks() > 0) {
  let select = document.getElementById('ophaengskroge-variant-select');
  let txt = '', pris = '';
  let qty = window.getOphaengskrogeQty ? window.getOphaengskrogeQty() : '';
  let packs = window.getOphaengskrogePacks ? window.getOphaengskrogePacks() : '';
  if (select) {
    let opt = select.options[select.selectedIndex];
    txt = opt.textContent;
    pris = (parseFloat(opt.getAttribute('data-price')) * packs).toLocaleString('da-DK', {style:'currency', currency:'DKK'});
  }
  lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Ophængskroge (${txt}) x${qty}</span><span class="pv2-summary-list-price">${pris}</span></div>`);
}


 // Fastgørelse
var foundationCard = document.getElementById('foundation-type-card');
if (foundationCard) {
  var sel = foundationCard.querySelector('.pv2-option-value-item.active');
  if (sel) {
    var method = sel.getAttribute('data-value');
    var methodText = '';
    if (method === 'ved-ikke') methodText = 'Ved ikke endnu';
    else if (method === 'punktsobning' || method === 'punktstobning') methodText = 'Punktstøbning';
    else if (method === 'skruer') methodText = 'Skruer';
    else methodText = sel.textContent?.trim() || method; // fallback hvis der er et andet navn
    lines.push(`<div class="pv2-summary-list-row"><span class="pv2-summary-list-label">Fastgørelse</span><span class="pv2-summary-list-value">${methodText}</span></div>`);
  }
}


  if (listElem) listElem.innerHTML = lines.join('');
  if (modalTotal) modalTotal.textContent = document.getElementById('pv2-summary-total')?.textContent || '';
  if (modalProductTitle) modalProductTitle.textContent = document.getElementById('pv2-summary-product-title')?.textContent || '';
}



// --- Åbn modal (oversigt) ---
document.getElementById('sticky-summary-overview-btn')?.addEventListener('click', function() {
  updateSummaryModal();
  document.getElementById('pv2-summary-modal')?.classList.add('active');
});
document.getElementById('pv2-summary-close')?.addEventListener('click', function() {
  document.getElementById('pv2-summary-modal')?.classList.remove('active');
});

// --- Kald også update ved load ---
updateAllSummaries();


// --- Funktion: Opdater prisen i alle title-bokse (alle .price-sale) ---
function updateTitleBoxPrice() {
  // 1) Find alle .price-sale (hvis du har to title-bokse med denne klasse)
  var titlePriceEls = document.querySelectorAll('.price-sale');
  if (!titlePriceEls || titlePriceEls.length === 0) return;

  // 2) Hent den valgte variant
  var variant = getSelectedVariant();
  if (!variant) {
    // Hvis ingen variant er valgt, ryd blot felterne (eller behold en tom streng)
    titlePriceEls.forEach(function(el) {
      el.textContent = '';
    });
    return;
  }

  // 3) Start med grundprisen (i kroner)
  var total = variant.price / 100;

  // 4) Læg eventuelle ekstra-priser på (kopier fra updatePv2Summary)
  if (typeof ekstraDorAktiv !== 'undefined' && ekstraDorAktiv && ekstraDorVariantId && ekstraDorQty > 0) {
    var sel = document.getElementById('extra-door-variant-select');
    if (sel) {
      var opt  = sel.options[sel.selectedIndex];
      var pris = parseFloat(opt.getAttribute('data-price')) * ekstraDorQty;
      total += pris;
    }
  }

  if (window.getOphaengskrogeAktiv && window.getOphaengskrogeAktiv()
      && window.getOphaengskrogeVariantId && window.getOphaengskrogePacks && window.getOphaengskrogePacks() > 0) {
    var sel2    = document.getElementById('ophaengskroge-variant-select');
    var packs   = window.getOphaengskrogePacks();
    if (sel2) {
      var opt2  = sel2.options[sel2.selectedIndex];
      var pris2 = parseFloat(opt2.getAttribute('data-price')) * packs;
      total += pris2;
    }
  }

  if (window.getFoundationActive && window.getFoundationActive()
      && window.getFoundationVariantId && window.getFoundationQty && window.getFoundationQty() > 0) {
    total += window.getFoundationPrice ? window.getFoundationPrice() : 0;
  }

  if (window.getAutoOplukAktiv && window.getAutoOplukAktiv()
      && window.getAutoOplukVariantId && window.getAutoOplukQty && window.getAutoOplukQty() > 0) {
    var sel3  = document.getElementById('auto-opluk-variant-select');
    var qty3  = window.getAutoOplukQty();
    if (sel3) {
      var opt3  = sel3.options[sel3.selectedIndex];
      var pris3 = parseFloat(opt3.getAttribute('data-price')) * qty3;
      total += pris3;
    }
  }

  if (window.getRidgeDecorationAktiv && window.getRidgeDecorationAktiv()
      && window.getRidgeDecorationVariantId) {
    var sel4  = document.getElementById('ridge-decoration-variant-select');
    if (sel4) {
      var opt4  = sel4.options[sel4.selectedIndex];
      var pris4 = parseFloat(opt4.getAttribute('data-price')) || 0;
      total += pris4;
    }
  }

  if (window.getMontageReferralAktiv && window.getMontageReferralAktiv()
      && window.getMontageReferralVariantId) {
    var sel5  = document.getElementById('montage-referral-variant-select');
    if (sel5) {
      var opt5  = sel5.options[sel5.selectedIndex];
      var pris5 = parseFloat(opt5.getAttribute('data-price')) || 0;
      total += pris5;
    }
  }

  if (window.selectedShelvesForCart && window.selectedShelvesForCart.length) {
    var shelfTotal = 0;
    window.selectedShelvesForCart.forEach(function(sel) {
      var qty    = sel.quantity;
      var input  = document.querySelector('.shelf-qty-input[data-variant="'+sel.id+'"]');
      var price  = input ? parseFloat(input.getAttribute('data-price')) : 0;
      shelfTotal += price * qty;
    });
    var totalShelves      = window.selectedShelvesForCart.reduce((acc, s) => acc + s.quantity, 0);
    var shelfDiscountRate = getShelfDiscountRate(totalShelves);
    var shelfDiscountAmt  = shelfTotal * shelfDiscountRate;
    var shelfNet          = shelfTotal - shelfDiscountAmt;
    total += shelfNet;
  }

  // 5) Formatér summen som DKK og skriv ind i alle .price-sale
  var formatted = total.toLocaleString('da-DK', {
    style:    'currency',
    currency: 'DKK'
  }).replace(',00','');

  titlePriceEls.forEach(function(el) {
    el.textContent = formatted;
  });
}


function updateAllSummaries () {
  updateStickySummaryBox();
  updateSummaryModal();
  updateTitleBoxPrice();        // salgspris
  updateComparePriceDynamic();  // før-pris  ◄──  NY LINJE
}


// --- Bind updateAllSummaries på alle relevante events ---
[
  '.pv2-option-value-item',
  '#extra-door-variant-select',
  '#extra-door-qty-select',
  '#auto-opluk-variant-select',
  '#auto-opluk-qty-select',
  '#ridge-decoration-variant-select',
  '#montage-referral-variant-select',
  '.shelf-qty-input',
  '#ophaengskroge-variant-select',
  '#ophaengskroge-qty-select',
  '#foundation-accessory-variant-select',
  '#foundation-accessory-qty-select'
].forEach(function(selector) {
  document.querySelectorAll(selector).forEach(function(el) {
    el.addEventListener('click',  updateAllSummaries);
    el.addEventListener('change', updateAllSummaries);
    el.addEventListener('input',  updateAllSummaries);
  });
});

// --- Kør én gang ved load, så priserne er korrekte fra starten ---
document.addEventListener('DOMContentLoaded', function() {
  updateAllSummaries();
});

  
});


document.addEventListener('DOMContentLoaded', function() {
  var stickyBox       = document.getElementById('sticky-summary-box');
  var addToCartBtn    = document.querySelector('.btn.btn--full.add-to-cart');
  var summaryTotalEl  = document.querySelector('.pv2-summary-total');

  // Helper: is element visible _inside_ the given container (or viewport if container is null)
  function isInViewport(el, container) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    var bounds = container
      ? container.getBoundingClientRect()
      : { top: 0, left: 0, bottom: window.innerHeight, right: window.innerWidth };
    return rect.bottom > bounds.top && rect.top < bounds.bottom;
  }

  function handleStickyBoxVisibility() {
    var container = (window.innerWidth > 768)
                  ? document.querySelector('.pv2-design-right')
                  : null;

    var addVisible     = isInViewport(addToCartBtn,   container);
    var totalVisible   = isInViewport(summaryTotalEl, container);

    // Hide sticky box if either the Add-to-Cart or the summary total is in view
    stickyBox.style.display = (addVisible || totalVisible)
                            ? 'none'
                            : 'flex';
  }

  // Wire up scroll events:
  if (window.innerWidth > 768) {
    // desktop: watch the design-right container
    var scrollContainer = document.querySelector('.pv2-design-right');
    scrollContainer && scrollContainer.addEventListener('scroll', handleStickyBoxVisibility, { passive: true });
  } else {
    // mobile: watch the window
    window.addEventListener('scroll', handleStickyBoxVisibility, { passive: true });
  }

  // Always also watch resize (in case user rotates or resizes)
  window.addEventListener('resize', handleStickyBoxVisibility);

  // MutationObserver + interval fallback for dynamic content:
  var observer = new MutationObserver(handleStickyBoxVisibility);
  observer.observe(document.body, { childList: true, subtree: true });
  setInterval(handleStickyBoxVisibility, 500);

  // Initial run:
  handleStickyBoxVisibility();

  // Hook up the sticky “Add to cart” button:
  var stickyCartBtn = document.getElementById('sticky-summary-cart-btn');
  stickyCartBtn && stickyCartBtn.addEventListener('click', function() {
    addToCartBtn && addToCartBtn.click();
  });

  // Hook up the sticky “overview” button to open your modal:
  var overviewBtn  = document.getElementById('sticky-summary-overview-btn');
  var summaryModal = document.getElementById('pv2-summary-modal');
  if (overviewBtn && summaryModal) {
    overviewBtn.addEventListener('click', function() {
      if (typeof updateSummaryModal === 'function') updateSummaryModal();
      summaryModal.classList.add('active');
    });
  }
});



document.addEventListener('DOMContentLoaded', function() {
  var foundationItems = document.querySelectorAll('#foundation-type-card .pv2-option-value-item');
  var foundationAccessory = document.getElementById('foundation-accessory-options');
  var imageElem = document.getElementById('foundation-type-image');

  foundationItems.forEach(function(item) {
    item.addEventListener('click', function() {
      foundationItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      // Skift hovedbilledet til det rigtige
      var newImg = item.getAttribute('data-img');
      if (imageElem && newImg) imageElem.src = newImg;
      // Vis dækkappe-vælger kun ved "skruer"
      if(item.getAttribute('data-value') === 'skruer') {
        foundationAccessory.style.display = '';
      } else {
        foundationAccessory.style.display = 'none';
      }
    });
  });
});